import { axiosEduServer } from "../utils/configAxios";

export const crearRegistro = (data) => {
  return axiosEduServer.post('/registro', data).then(({ data }) => data).catch((err) => { throw err });
};

export const actualizarRegistro = (id, data) => {
  return axiosEduServer.put(`/registro/${id}`, data).then(({ data }) => data).catch((err) => { throw err });
};

export const eliminarRegistro = (id) => {
  return axiosEduServer.delete(`/registro/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getOneRegistro = (id) => {
  return axiosEduServer.get(`/registro/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getAllRegistros = () => {
  return axiosEduServer.get('/registro').then(({ data }) => data).catch((err) => { throw err });
};

export const getAllRegistrosByIdEstudianteIdIdiomaEstado = (idEstudiante, idIdioma, estado) => {
  return axiosEduServer.get(`/registro/idestudiante/${idEstudiante}/ididioma/${idIdioma}/estado/${estado}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getAllRegistrosByIdDocenteIdIdiomaIdGrupoEstado = (idDocente, idIdioma, idGrupo, estado) => {
  return axiosEduServer.get(`/registro/iddocente/${idDocente}/ididioma/${idIdioma}/idgrupo/${idGrupo}/estado/${estado}`).then(({ data }) => data).catch((err) => { throw err });
};

// Obtener todos los registros de un grupo (todos los estados: Progreso, Aprobado, Reprobado)
export const getAllRegistrosByIdDocenteIdIdiomaIdGrupo = async (idDocente, idIdioma, idGrupo) => {
  try {
    const [progreso, aprobado, reprobado] = await Promise.allSettled([
      axiosEduServer.get(`/registro/iddocente/${idDocente}/ididioma/${idIdioma}/idgrupo/${idGrupo}/estado/Progreso`),
      axiosEduServer.get(`/registro/iddocente/${idDocente}/ididioma/${idIdioma}/idgrupo/${idGrupo}/estado/Aprobado`),
      axiosEduServer.get(`/registro/iddocente/${idDocente}/ididioma/${idIdioma}/idgrupo/${idGrupo}/estado/Reprobado`)
    ]);

    const resultados = [];
    if (progreso.status === 'fulfilled') resultados.push(...(progreso.value.data || []));
    if (aprobado.status === 'fulfilled') resultados.push(...(aprobado.value.data || []));
    if (reprobado.status === 'fulfilled') resultados.push(...(reprobado.value.data || []));

    return resultados;
  } catch (err) {
    throw err;
  }
};

export const actualizarRegistroNota = (id, data) => {
  return axiosEduServer.put(`/registro/${id}`, data).then(({ data }) => data).catch((err) => { throw err });
};

export const actualizarRegistroCongelado = (id, data) => {
  return axiosEduServer.put(`/registro/congelado/${id}`, data).then(({ data }) => data).catch((err) => { throw err });
};
